const settingsDanish = {
  header: {
    title: "LinkedIn Indstillinger",
    description: "Tilknyt din LinkedIn-konto for at få adgang til systemet",
    descriptionEmployee: "Tilknyt dine konti for at komme i gang"
  },
  messages: {
    success: "Succes!",
    error: "Der opstod en fejl",
    closeButton: "Luk"
  },
  linkedin: {
    title: "LinkedIn Profil",
    loading: "Indlæser...",
    connected: "LinkedIn profil tilknyttet",
    description: "Tilknyt din LinkedIn profil for at kunne lave opslag",
    connectButton: "Forbind LinkedIn",
    disconnectButton: "Afkobl LinkedIn",
    profileInfo: {
      unnamed: "Unavngivet bruger",
      status: "Status:",
      active: "Aktiv",
      expires: "Udløber:",
      expiresIn: "Om {days} dage",
      unknown: "Ukendt",
      noProfileData: "Kunne ikke hente profildata. Prøv at frakoble og forbinde igen."
    }
  },
  telegram: {
    title: "Telegram Bot",
    description: "Tilknyt Telegram for at generere og modtage LinkedIn-opslag direkte",
    connected: "Telegram er tilknyttet",
    connectButton: "Tilknyt Telegram",
    disconnectButton: "Afkobl Telegram",
    generating: "Genererer kode...",
    connectionGuide: {
      title: "Sådan tilknytter du din Telegram",
      steps: [
        "Åbn Telegram og søg efter NuvikAI_bot",
        "Start botten ved at skrive /start",
        "Send denne kode til botten:"
      ],
      expires: "Koden udløber om 15 minutter"
    }
  },
  deliverySettings: {
    title: "Leveringsindstillinger",
    description: "Vælg hvor du vil modtage dine ugentlige AI-genererede LinkedIn-opslag",
    options: {
      website: "På hjemmesiden",
      telegram: "Via Telegram"
    },
    helpText: {
      website: "Dine opslag vil blive vist i \"LinkedIn AI Generator\" afsnittet i app'en.",
      telegram: "Dine opslag vil blive sendt direkte til dig via Telegram."
    }
  },
  readyCard: {
    title: "Alt er klar!",
    description: "Du kan nu bruge Telegram til at generere og publicere LinkedIn-opslag, eller se dine genererede opslag direkte i appen.",
    viewPostsButton: "Se dine opslag"
  },
  customerSuccess: {
    title: "LinkedIn-konto tilknyttet!",
    description: "Din LinkedIn-konto er nu tilknyttet. Du vil nu modtage indhold fra systemet som vil blive delt på din LinkedIn-profil."
  },
  language: {
    title: "Sprog",
    description: "Vælg dit foretrukne sprog"
  }
};

export default settingsDanish; 